// Material UI
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

import brands from "../../../Utilities/Brands";


const GenerateOptOutSearchFormSocial = (
  brandId,
  setBrandId,
  social,
  setSocial
) => {


  const formLabels = [
    {
      Label: "Brand",
      Element: "FormControl",
      Value: brandId,
      Setter: setBrandId,
      Data:
      <>
      <option value="" key="-1" />
      <option value="0" key="0">All</option>
        {brands.map((card, _idx) => {
          return (
            <option key={card._id} value={card._id}>
              {card.brand}
            </option>
          );
        })}
      </>
    },
    {
      Label: "Social",
      Element: "TextField",
      Value: social,
      Setter: setSocial,
      Type: "tel"
    }
  ];


  return formLabels.map(
    ({ Label, Element, Type, Data, Value, Setter }, idx) => {
      switch (Element) {
        case "TextField":
          return (
            <TextField
              key={idx}
              id="outlined-full-width"
              className="input-el"
              label={Label}
              type={Type}
              style={{ margin: 8, width: "14rem" }}
              fullWidth={false}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              value={Value}
              onChange={(e) => {
                  // stop spaceBar from being added
                  const inputSocial = e.target.value.replace(/\s/g,'');
                  Setter(inputSocial);
                }
              }
            />
          );
        case "FormControl":
          return (
              <FormControl
                key={idx}
                variant="outlined"
                style={{ margin: 8, width: "14rem" }}
                value={Value}
                onChange={(e) => Setter(e.target.value)}
              >
                <InputLabel htmlFor="outlined-age-native-simple">
                  {Label}
                </InputLabel>
                <Select
                  native={true}
                  label={Label}
                  value={Value}
                  inputProps={{
                    name: `${Label.toLowerCase()}`,
                    id: `outlined-${Label.toLowerCase()}-native-simple`,
                  }}
                >
                  {Data}
                </Select>
              </FormControl>
            );
        default:
          return null;
      }
    }
  );
};

export default GenerateOptOutSearchFormSocial;
